import { render, staticRenderFns } from "./SolidRing.vue?vue&type=template&id=f30c58dc&scoped=true"
import script from "./SolidRing.vue?vue&type=script&lang=js"
export * from "./SolidRing.vue?vue&type=script&lang=js"
import style0 from "./SolidRing.vue?vue&type=style&index=0&id=f30c58dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30c58dc",
  null
  
)

export default component.exports